module.exports = __webpack_public_path__ + "img/org-review-bad.ab53585c.svg";